import { useGetSubscriptionStatusQuery } from '@viome/viome-base/src/usecase/Misc/MiscQuery';
import { SubscriptionStatus } from '@viome/viome-base/src/usecase/Misc/MiscModel';
import { SMP_PATH, SMP_DETAIL_PATH } from '@/constants/paths';
import { isEligibleForComponentization } from '@/utils/componentizationEligibility';
import { useIsComponentizationEnabled } from '@/hooks/useIsComponentizationEnabled';
import { useComponentizationEligibleSkus } from '@/hooks/useComponentizationEligibleSkus';

/**
 * Builds the "Manage my subscription" target for the formulas gateways.
 * Those CTAs manage the supplement subscription, so we resolve an active or
 * paused (i.e. manageable) supplement `subscription_id` and pass it as the
 * canonical `?subscriptionId=`. A cancelled supplement is skipped so its id
 * doesn't override SMP's own active/paused derive.
 * Falls back to bare `/smp` when no manageable supplement sub is found or the
 * list hasn't loaded — SMP then derives the subscription itself (deeplink).
 */
export const useManageSubscriptionLink = () => {
  const isComponentizationEnabled = useIsComponentizationEnabled();
  const eligibleSkus = useComponentizationEligibleSkus();
  const { data } = useGetSubscriptionStatusQuery();

  const supplementSub = data?.subscriptions?.find(
    (subscription) =>
      (subscription.category ?? '').toUpperCase() !== 'KIT' &&
      (subscription.subscription_status === SubscriptionStatus.Active ||
        subscription.subscription_status === SubscriptionStatus.Paused),
  );

  if (!supplementSub) return SMP_PATH;

  const targetPath =
    isComponentizationEnabled &&
    isEligibleForComponentization(supplementSub, eligibleSkus)
      ? SMP_DETAIL_PATH
      : SMP_PATH;
  return `${targetPath}?subscriptionId=${supplementSub.subscription_id}`;
};
